import React from "react";
import "./about.less";

const about = new URL("../../assets/about.png", import.meta.url).href;
const about1 = new URL("../../assets/about1.png", import.meta.url).href;
const about2 = new URL("../../assets/about2.png", import.meta.url).href;
const about3 = new URL("../../assets/about3.png", import.meta.url).href;

const About: React.FC = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about__hero">
        <div className="about__hero-text">
          <h1>
            About <span>us</span>
          </h1>
          <p>
            Empowering financial intelligence through innovation, analytics, and
            expert-driven solutions.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="about__content">
        {/* Top Part */}
        <div className="about__content-top">
          <div className="about__content-left">
            <h2>
              Company <span>Profile</span>
            </h2>
            <p>
              CareEdge Analytics and Advisory Private Limited (CAAPL), as a
              leading-edge analytics and advisory firm specializing in solutions
              for banks and financial institutions, offers a tailored suite of
              products and services to address various aspects of risk
              management and financial operations.
            </p>
            <p>
              CAAPL delivers a comprehensive suite of offerings, including Risk
              Analytics , Advanced AI/ML-driven Custom Analytics, Expert Risk
              Consulting and Digital Service, empowering banks to effectively
              manage risks, optimize performance, and navigate the evolving
              financial landscape with compliance and innovation. With a proven
              track record of over 100 successful implementations across the Sri
              Lanka, Bhutan, and India regions, CAAPL demonstrates its expertise
              and commitment to delivering excellence in the banking sector. As
              a 100% subsidiary of Care Ratings, CAAPL benefits from the
              strength and expertise of its parent company, further enhancing
              its ability to deliver cutting-edge analytics solutions to banks
              worldwide.
            </p>
          </div>

          <div className="about__content-right">
            <img src={about} alt="Company discussion" />
          </div>
        </div>

        {/* Bottom Part */}
        <div className="about__content-bottom">
          <div className="about__card">
            <img src={about1} alt="Vision" className="about__card-img" />
            <h3 className="about__card-title">
              Our <span>Vision</span>
            </h3>
            <p className="about__card-desc">
              A global research & analytics company that enables risk mitigation
              and superior decision making.
            </p>
          </div>

          <div className="about__card">
            <img src={about2} alt="Mission" className="about__card-img" />
            <h3 className="about__card-title">
              Our <span>Mission</span>
            </h3>
            <p className="about__card-desc">
              To provide best-in-class tools, analyses and insights, enabling
              customers to make informed decisions.
            </p>
          </div>

          <div className="about__card">
            <img src={about3} alt="Values" className="about__card-img" />
            <h3 className="about__card-title">
              Our <span>Values</span>
            </h3>
            <p className="about__card-desc">
              Integrity, Pursuit of Excellence, Commitment, Fairness.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
